import { forEach, merge, find, isEmpty } from 'lodash';

class HelmetStore {
  constructor() {
    this.bindActions(this.alt.getActions('Helmet'));

    this.title = '';
    this.titleBase = 'Frankly News';
    this.metas = [];
    this.statusCode = 200;

    this.updateTitleSources = {
      'route': '',
      'primaryContentSource': ''
    };
    this.errors = {};
  }

  onUpdate(props) {
    Object.keys(props)
      .forEach((key) => this[key] = props[key]);
  }

  onUpdateTitleSuccess([updateSource, title]) {
    if (updateSource in this.updateTitleSources) {
      this.updateTitleSources[updateSource] = title;
      this._updateTitle();

      delete this.errors['updateTitle'];
    }
  }

  onUpdateTitleFail({ error }) {
    this.errors['updateTitle'] = error;
  }

  _updateTitle() {
    const { route, primaryContentSource } = this.updateTitleSources;
    this.title = route || primaryContentSource;
  }

  onUpdateMetas(props) {
    const {metas = {}} = props;

    //WEB-4884:add <link rel="amphtml" href="page URL"> to metadata
    if (metas.length === 1 && metas[0].rel === 'amphtml') {
      this.metas.push(metas[0]);
      return;
    }

    forEach(this.metas, (meta, key) => {
      const { name, rel, property } = meta;
      merge(this.metas[key], find(metas, item => {
        const { name: nameData = '', rel: relData = '', property: propertyData = '', content, href } = item;
        //handle for url meta tags
        if (relData) {
          return relData === rel && !isEmpty(href);
        }

        return (nameData === name || propertyData === property) && !isEmpty(content);
      }));
    });
  }

}

export default HelmetStore;



// WEBPACK FOOTER //
// ./app/flux/stores/Helmet.js